var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgESprawozdaniaStartErrorPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA3350B4-26CE-44B5-ACCF-8DD2DC0B7D31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M117.333333,21.3333333 L117.333333,18.6666667 C117.333333,11.3066667 111.36,5.33333333 104,5.33333333 C96.64,5.33333333 90.6666667,11.3066667 90.6666667,18.6666667 L90.6666667,21.3333333 C87.7333333,21.3333333 85.3333333,23.7333333 85.3333333,26.6666667 L85.3333333,48 C85.3333333,50.9333333 87.7333333,53.3333333 90.6666667,53.3333333 L117.333333,53.3333333 C120.266667,53.3333333 122.666667,50.9333333 122.666667,48 L122.666667,26.6666667 C122.666667,23.7333333 120.266667,21.3333333 117.333333,21.3333333 Z M113.066667,21.3333333 L94.9333333,21.3333333 L94.9333333,18.6666667 C94.9333333,13.6533333 98.9866667,9.6 104,9.6 C109.013333,9.6 113.066667,13.6533333 113.066667,18.6666667 L113.066667,21.3333333 Z M100.906667,64 C101.12,65.76 101.333333,67.52 101.333333,69.3333333 C101.333333,80.4266667 97.0666667,90.5066667 90.1333333,98.08 C88.7466667,93.76 84.8,90.6666667 80,90.6666667 L74.6666667,90.6666667 L74.6666667,74.6666667 C74.6666667,71.7333333 72.2666667,69.3333333 69.3333333,69.3333333 L37.3333333,69.3333333 L37.3333333,58.6666667 L48,58.6666667 C50.9333333,58.6666667 53.3333333,56.2666667 53.3333333,53.3333333 L53.3333333,42.6666667 L64,42.6666667 C69.8666667,42.6666667 74.6666667,37.8666667 74.6666667,32 L74.6666667,18.4533333 C69.6,16.8533333 64.2666667,16 58.6666667,16 C29.2266667,16 5.33333333,39.8933333 5.33333333,69.3333333 C5.33333333,98.7733333 29.2266667,122.666667 58.6666667,122.666667 C88.1066667,122.666667 112,98.7733333 112,69.3333333 C112,67.52 111.893333,65.76 111.733333,64 L100.906667,64 Z M53.3333333,111.626667 C32.2666667,109.013333 16,91.0933333 16,69.3333333 C16,66.0266667 16.4266667,62.88 17.12,59.7866667 L42.6666667,85.3333333 L42.6666667,90.6666667 C42.6666667,96.5333333 47.4666667,101.333333 53.3333333,101.333333 L53.3333333,111.626667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2.0-E-SPRAWOZDANIE---START-BRAK-LICENCJI",
    transform: "translate(-593.000000, -229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Szambelan",
    transform: "translate(357.000000, 233.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grafika",
    transform: "translate(240.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 116,
    cy: 116,
    r: 116
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,232 C180.065031,232 232,180.065031 232,116 C232,51.934969 180.065031,0 116,0 C51.934969,0 0,51.934969 0,116",
    id: "Oval",
    stroke: "#D0021B",
    strokeWidth: 8,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(116.000000, 116.000000) rotate(90.000000) translate(-116.000000, -116.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/VPN-locked",
    opacity: 0.384347098,
    transform: "translate(52.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Black-38%",
    mask: "url(#mask-2)",
    fill: "#000000",
    fillOpacity: 0.38,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgESprawozdaniaStartErrorPage);
export default __webpack_public_path__ + "static/media/eSprawozdania_StartErrorPage.e5866d09e737b51757e185415cd9250a.svg";
export { ForwardRef as ReactComponent };